﻿const INPUTS_NUMBER = 6;

export class Code {
  constructor(element) {
    this.element = $(element);
    this.digits = $(".eui-security-code-digit input", $(element));
    this.error = $(".eui-security-code__error", element);

    this.digits.on("focusin", (event) => {
      $(event.target).trigger("select");
    });

    this.digits.on("keyup", (event) => {
      const digit = $(event.target);

      if (event.keyCode === 8 && digit.val() === "") {
        const prevDigitIndex = this.digits.index(digit) - 1;
        const prevDigit = this.digits.eq(
          prevDigitIndex < 0 ? 0 : prevDigitIndex
        );

        prevDigit.trigger("select");
      }
    });

    this.digits.on("input", (event) => {
      this.setValidation(true);

      const digit = $(event.target);

      if (digit.val().length > 1 && digit.val().length !== INPUTS_NUMBER) {
        digit.val(digit.val().slice(0, 1));
      } else if (digit.val().length === INPUTS_NUMBER) {
        const codeVal = digit.val();
        new Array(INPUTS_NUMBER).fill(true).forEach((item, index) => {
          $(this.digits[index]).val(codeVal[index]);
        });

        if (this.isFilled()) {
          clearTimeout(this.filledTimer);
          this.filledTimer = setTimeout(() => {
            this.element.trigger("filled", this.getValue());
          }, 1000);
        }

        return;
      }

      if (!/\d/.test(digit.val())) {
        digit.val("");
      }

      if (digit.val() !== "") {
        const nextDigitIndex = this.digits.index(digit) + 1;
        const nextDigit = this.digits.eq(nextDigitIndex);

        nextDigit.trigger("focus");
      }

      if (this.isFilled()) {
        clearTimeout(this.filledTimer);
        this.filledTimer = setTimeout(() => {
          this.element.trigger("filled", this.getValue());
        }, 1000);
      }
    });
  }

  isFilled() {
    for (let i = 0; i < this.digits.length; i++) {
      const digit = this.digits.get(i);

      if ($(digit).val() === "") {
        return false;
      }
    }

    return true;
  }

  getValue() {
    let code = "";
    this.digits.each((index, digit) => {
      code = code.concat($(digit).val());
    });

    return code;
  }

  setValidation(isValid) {
    if (isValid) {
      this.error.addClass("eui-d-none");
      this.digits
        .closest(".eui-security-code")
        .removeClass("eui-security-code--error");
    } else {
      this.error.removeClass("eui-d-none");
      this.digits
        .closest(".eui-security-code")
        .addClass("eui-security-code--error");
    }
  }
}
